import type { HelpFile } from '../../types/help'
import { CertificationPolicyDetailTestIds } from '../../../testids/CertificationPolicyDetailTestIds'

export const certificationPolicyDetailHelp: HelpFile = {
  docPage: '/docs/governance/certification-policies',
  texts: {
    [CertificationPolicyDetailTestIds.certificationPolicyDetailPage]:
      'Read-only summary of this certification policy. Use the per-section Edit buttons to change it in the wizard.',
    [CertificationPolicyDetailTestIds.badgeCampaignCount]:
      'Number of certification campaigns already generated from this policy.',
    [CertificationPolicyDetailTestIds.btnCreateCampaign]:
      'Create a new certification campaign from this policy in staging status.',
    [CertificationPolicyDetailTestIds.btnDelete]:
      'Permanently delete this policy. Campaigns already generated from it are not affected.',
    [CertificationPolicyDetailTestIds.btnEditBasics]:
      'Open the Basics section of the policy wizard to edit name, description, priority, and date range.',
    [CertificationPolicyDetailTestIds.btnEditScope]:
      'Open the Scope step of the policy wizard to edit which access assignments are covered.',
    [CertificationPolicyDetailTestIds.btnEditReviewSettings]:
      'Open the Review Settings step to change reviewer type, frequency, and non-response action.',
    [CertificationPolicyDetailTestIds.sectionBasics]:
      'Core identity of the policy — name, description, priority, and the effective period.',
    [CertificationPolicyDetailTestIds.sectionScope]:
      'Defines which access assignments this policy certifies — either structured conditions or a CEL expression.',
    [CertificationPolicyDetailTestIds.sectionReviewSettings]:
      'Controls the review cadence — who reviews, how often, grace period, and what happens when a reviewer does not respond.',
    [CertificationPolicyDetailTestIds.sectionBasicsTitle]: null,
    [CertificationPolicyDetailTestIds.sectionScopeTitle]: null,
    [CertificationPolicyDetailTestIds.sectionReviewSettingsTitle]: null,
    [CertificationPolicyDetailTestIds.infoDefaultPolicy]: null,
    [CertificationPolicyDetailTestIds.infoOpenCampaignWarning]: null,
    [CertificationPolicyDetailTestIds.policyOwner]: null,
  },
}
